import { PricingTypeEnum } from '@/enums/rights';

/** 权益额外字段，根据资方code统计落库 */
export interface RightExtendDataType {
    capitalCode?: string,
    /** 下单来源 */
    helloFrom?: string,
}

/** 权益支付地址入参类型 */
export interface GetRightPayParamsType {
    /** 支付金额 */
    payAmount?: string;
    /** 期望价格，仅做优惠对比，实际下单不使用该字段 */
    expectPrice: string;
    /** packageId */
    packageId: string;
    /** 产品id */
    productId: string;
    /** 扩展字段定义,capitalCode:资方code */
    extendDataJson: RightExtendDataType;
    /** 支付完成回调地址 */
    returnUrl?: string;
    /** 权益模型标识 为了区分24+权益使用新的库表给后端透传的字段  */
    rightsModelType?: number,
}

/** 权益合同入参类型 */
export interface GetRightContractType {
    /** 合同模版id */
    templateId: string,
    /** 合同扩展字段，为后端合同填充的字段做预留，暂时未用到 */
    extraParams?: Dictionary,
}

/** 权益合同类型枚举 */
export enum RightContractTypeEnum {
    /** 《权益服务协议》 */
    SERVICE = 'SERVICE',
    /** 《用户个人信息授权》 */
    SELF_INFO = 'SELF_INFO',
    /** 《委托扣款授权书》 */
    DEDUCTION = 'DEDUCTION',
}

/** 会员卡类型枚举 */
export enum RightPackageTypeEnum {
    /** 臻享卡 */
    CHANNEL_B = 4,
    /** 臻还卡 */
    REPAYMENT_CARD = 5,
    /** @deprecated 臻乐卡 */
    HAPPY_CARD = 6,
    /** @deprecated 臻快卡 */
    FAST_CARD = 7,
    /** 超级会员卡 */
    SUPER_MEMBER_CARD = 8,
    /** 臻享会员卡, 需求链接：https://hellobike.yuque.com/g/yxr77w/hx3sqh/sb03g8kz7od3wcdk/collaborator/join?token=bUXC0YHuqRfNV6uW&source=doc_collaborator#  */
    ZHEN_XIANG_MEMBER_CARD = 9,
    /** 超级会员PLUS卡 */
    SUPER_MEMBER_PLUS_CARD = 10,
}

/** 样式类型 */
export enum StyleTypeEnum {
    /** 单权益样式 */
    SINGLE_STYLE = 6001,
    /** 多权益样式 */
    MORE_STYLE = -1,
}

/** 权益相关接口调用环节 */
export enum RightPackageSourceEnum {
    /** 提现环节 */
    LOAN = 'credit_loan',
    /** 提现申请中 */
    LOAN_APPLYING = 'credit_loan_apply',
    /** 授信失败 */
    CREDIT_FAILED = 'credit_application_failed',
    /** 授信申请中 */
    CREDIT_ING = 'credit_application',
    /** 首页召回 - 首页权益入口 */
    FINANCE_HOME_CALLBACK = 'finance_member_saveModular',
    /** 提现结果页弹窗 */
    LOAN_RESULT_POP = 'finance_loan_applyResult_member_savePop',
    /** 提现页 */
    LOAN_APPLY = 'finance_loan_apply_page',
    /** 提现结果页 */
    LOAN_APPLY_RESULT = 'finance_loan_apply_result',
    /** 提现页-权益卡单 */
    LOAN_APPLY_STUCK = 'finance_loan_apply_stuck',
    /** 首页提现弹窗 */
    FINANCE_HOME_CREDIT_LOAN_APPLY = 'finance_home_credit_loan_apply',
    /** 首页提现弹窗-点击详情进入主流程页面 */
    FINANCE_HOME_CREDIT_LOAN_APPLY_PAGE_DETAIL = 'finance_home_credit_loan_apply_page_detail',
}

/** 权益相关接口调用环节 */
export enum SuperMemberSourceEnum {
    /** 会员入口主tab */
    TAB = 'finance_member_tab',
    /** 授信协议页 */
    CREDIT_AGREEMENT = 'finance_credit_agreement',
    /** 授信协议详情页 */
    CREDIT_AGREEMENT_DETAIL = 'finance_credit_agreement_cjhy_detail',
    /** 臻快卡支付弹窗 */
    ZKK_POP = 'finance_credit_loan_apply_zkk_payPopup',
    /** 提现页-点击详情进入主流程页面 */
    FINANCE_CREDIT_LOAN_APPLY_CJHY_DETAIL = 'credit_loan_apply_page_detail',
    /** 提现页 */
    FINANCE_CREDIT_LOAN_APPLY_CJHY = 'credit_loan_apply_page',
    /** 我的优惠卷页面 */
    MY_COUPON = 'finance_member_myCoupon',
    /** 提现记录空白页 */
    APPLY_NO_RECORD = 'finance_member_withdrawalRecord',
    /** 我的页面 */
    MY_PROFILE = 'finance_member_myProfile',
    /** 底部tab */
    FINANCE_MEMBER_TAB = 'finance_member_tab',
    /** 首页提现弹窗 */
    FINANCE_HOME_CREDIT_LOAN_APPLY = 'finance_home_credit_loan_apply',
    /** 首页提现弹窗-点击详情进入主流程页面 */
    FINANCE_HOME_CREDIT_LOAN_APPLY_PAGE_DETAIL = 'finance_home_credit_loan_apply_page_detail',
    /** 授信协议-贷超半流程节点 */
    FINANCE_DCHALFAPPLY_AGREEMENT = 'finance_dcHalfApply_agreement'
}

/** 权益场景类型枚举 */
export enum RightSummaryTypeEnum {
    /** 臻享卡自营B场景 */
    ZXK_SUMMARY = 'ZXK_SUMMARY',
    /** 臻享卡联营场景 */
    ZXK_JOINT_VENTURE = 'ZXK_JOINT_VENTURE'
}

/** 权益查询&下单参数 */
export interface RightsSummaryGet {
    /** 渠道id */
    productId: string;
    /** 外采访流量方id */
    sourceId?: string;
    /** 提现金额 */
    orderAmount: number;
    /** 提现期数 */
    period: number;
    /** 权益包类型 */
    packageType: RightPackageTypeEnum;
    /** 资方code
     * 1、8180自营必传
     * 2、联营存在没有的情况
     */
    capitalCode?: string;
    /** 定价类型
     * 用于区分模式二 和其他模式，模式二返回臻有钱权益，其他类型返回卖量权益
    */
    pricingType?: PricingTypeEnum;
    /** 利率数值字段 */
    rateValue?: number;
}

/** 卡种类型 */
export enum RightCardTypeEnum {
  /** 月卡 */
  MONTHLY = 1,
  /** 连续包月 */
  PERIOD_DEDUCTION_OPTION_MONTHLY = 2,
  /** 年卡 */
  YEARLY = 3,
}

/** 权益详情页类型 */
export enum LoanCardTypeEnum {
  /** 自营 */
  CHANNEL_B = 1,
  /** 联营 */
  JOINT_VENTURE = 2,
  /** 外采 */
  OUT_FLOW = 3,
  /** 轻资产 优速卡 */
  YOU_SU_CARD = 4,
  /** 渠道权益页 */
  CHANNEL_RIGHT = 5,
}
/** 权益概述 */
export interface RightSummaryType {
    /** 权益包id */
    packageId: string;
    /** 供应商code */
    supplierCode: string;
    /** 权益包code */
    packageCode: string;
    /** 原价 */
    originalPrice: number;
    /** 购买价 */
    sellPrice: number;
    /** 可省金额 */
    saveMoney: number;
    /** 权益模型标识 为了区分24+权益使用新的库表给后端透传的字段  */
    rightsModelType: number,
    /** 权益包类型 */
    packageType?: RightPackageTypeEnum;
    /** 权益包名称 */
    packageName?: string;
    /** 合同数据 */
    contractInfo: EquityContractType;
    /** 开启倒计时的倒计时时间 */
    countDownTime?: number;
    /** 本次请求的提现金额, 用于赋值校对 */
    orderAmount?: number;
    /** 本次请求的提现期数, 用于赋值校对 */
    period?: number;
    /** 产品id, 用于赋值校对 */
    productId?: string;
    /** 未开通权益详情页地址 */
    unopenedDetailUrl?: string;
    /** 是否自动续费 */
    periodType?: RightCardTypeEnum;
    /** 市场价 */
    marketPrice?: number;
    /** 臻享卡类型 */
    loanCardType?: LoanCardTypeEnum;
    extraInfo?: {
      /** 模式枚举，patternA：线上带金融权益的样式， patternB：合规样式*/
      pattern?: string;
      /** 样式实验枚举 */
      style?: GalileoExpStyleEnum;
    }
}

/** 权益合同 根据查询场景 获取不同协议列表 */
export enum ContractListSceneEnum {
    /** 自主支付, 目前场景为：信贷弹窗曝光 */
    AUTONOMY_PAY_SCENE = 'autonomyPayScene',
    /** 划扣支付，目前主要用于提现权益卡片tab */
    DEBIT_PAYMENT_SCENE = 'debitPaymentScene',
}

/** 权益召回 */
export interface CallbackType {
    /** 权益包id */
    packageId: string;
    /** 是否权益召回展示true展示，false不展示 */
    showPackageDetail: boolean;
    /** 召回文案 */
    callBackDocument: string;
    /** 需要展示的情况必传；权益批扣类型（普通权益common；极速权益speed） */
    orderPayTyp: string;
    /** 自营 B 资方 code */
    capitalCode?: string;
    /** 外采流量方id */
    sourceId?: string;
}

/** 权益概要接口 */
export interface GetRightSummaryType {
    /** 权益包类型 */
    packageType: RightPackageTypeEnum;
    /** 来源 */
    source: string;
    /** 产品id */
    productId: string;
    /** 最大可提现金额 */
    applyAmount?: string;
    /** 实际提现利率 */
    rateValue?: number;
    pricingType?: PricingTypeEnum;
}

/** 权益概要接口 */
export interface RightCheckResultType {
    /** 校验结果 */
    checkResult: boolean,
    /** 失败规则描述列表 */
    failedRuleList?: string[],
    /** 是否可购买 */
    canPurchase: boolean,
    /** 是否支持划扣方式支付 */
    supportProxyPay: boolean
}


/** 查询权益包数据的入参 */
export interface GetPackageDetailParamType {
    /** 权益包code */
    packageCode?: string;
    /** 当前权益包ID */
    packageId?: string;
    /** 订单id */
    orderId?: string;
    /** 权益卡类型 */
    packageType?: RightPackageTypeEnum;
}


export enum PackageBuyStatusEnum {
    /** 未购买 */
    NOT_BUY = 1,
    /** 购买成功 */
    BOUGHT = 2,
}

export enum ContractContentTypeEnum {
    /** pdf格式 */
    PDF = 1,
    /** html格式 */
    ELSE = 2,
}

export interface OutSideContractItem {
    /** 合同名称 */
    name: string;
    /** 合同类型 */
    contentType: ContractContentTypeEnum;
    /** 合同内容URL */
    contentUrl: string;
}

export interface EquityContractType {
    name: string;
    scene: ContractListSceneEnum;
    isUseContractList?: boolean;
    contractList?: OutSideContractItem[];
}

/**
 * 超级会员营销图样式AB实验
 */
export enum SuperMemberUnionCardStyleTypeEnum {
  /** 对照组 联营超会单行借还权益营销样式 */
  SINGLE_LOAN = 'jointSingleLoan',
  /** 实验组1 联营超会单行480元营销样式 */
  SINGLE480 = 'jointSingle480',
  /** 实验组2 联营超会多行480元营销样式 */
  MULTI480 = 'jointMulti480',
}

export interface BuyEquityResponseType {
    userId: string; /** 金融用户ID */
    productIdList: string[]; /** 产品ID集合 */
    needBuy: boolean; /** 是否展示超级会员栏 */
    title: string; /** 标题 */
    subTitle: string; /** 子标题 */
    bannerImg?: string; /** 卡片背景图 */
    packageBuyStatus: PackageBuyStatusEnum; /** 购买状态 */
    promotionTips?: string; /** 营销文案 */
    remindText?: string; /** 提醒文案 */
    packageId: string; /** 权益包ID */
    packageType: RightPackageTypeEnum; /** 权益包类型 */
    /** 供应商code */
    supplierCode: string;
    /** 权益包售价 */
    sellPrice: string;
    /** 合同数据 */
    contractInfo: EquityContractType;
    /** 立省金额 */
    saveMoney: string;
    /** 原始售价 */
    originalPrice: string;
    /** 扩展信息（JSON 字符串格式：{"style":"styleA"|"styleB"}） */
    extraInfo?: string;
}

export interface PreCreateRightRequestType {
    /** 权益包ID */
    packageId: string;
    /** 授信任务ID */
    creditTaskId: string;
     /** from */
    from: string;
    /** 是否为跟贷订单 */
    followLoan: boolean;
}

export interface CheckSuperCardTabResponseType {
    checkResult: boolean;
    /** 角标样式 */
    iconCode: TabStyleTypeEnum;
    /** 角标内容 */
    iconContent: string;
     /** 权益包类型 */
    packageType: RightPackageTypeEnum;
    /** 权益购买状态 */
    packageBuyStatus: PackageBuyStatusEnum;
}

/** 当前权益版式测试枚举 */
export enum CreditCardStyleTypeEnum {
    /** 对照组，自动续费文案调整至下方 */
    TEXT_DOWN = '0',
    /** 实验组1， 自动续费文案在右侧 */
    TEXT_RIGHT = '1',
    /** 实验组2， 自定续费文案左侧 */
    TEXT_LEFT = '2',
}

/** 当前权益版式测试枚举 */
export enum TabStyleTypeEnum {
    /** 无标签 */
    NO_ICON = 'noIcon',
    /** 文字标签 */
    TEXT_ICON = 'textIcon',
    /** 图片标签 */
    IMG_ICON = 'imgIcon',
}

/** 超级会员不同入口场景参数类型 */
export type SuperCardSummaryBackType = {
    /** 权益包code */
    packageCode?: string;
    /** 权益包ID */
    packageId?: string;
    /** 权益包名称 */
    packageName?: string;
    /** 权益包类型 */
    packageType?: RightPackageTypeEnum;
    /** 订单ID */
    orderId?: string;
    /** 供应商code */
    supplierCode?: string;
    /** 现售价,后端纠正字段，与下字段意义一致，但同时保留 */
    sellPrice?: string;
    /** 现售价 */
    /** @deprecated('sellerPrice is deprecated, use sellPrice instead') */
    sellerPrice?: string;
    /** 原价 */
    originalPrice?: string;
    /** 购买状态 */
    packageBuyStatus?: PackageBuyStatusEnum;
    /** 是否可以选择支付方式 */
    isSelectPayWay?: boolean;
    /** 支付方式 */
    payWay?: PayWayEnum;
    /** 支付方式说明 */
    payWayText?: string;
    /** 当前可省金额 */
    saveMoney?: string;
    /** 合同信息 */
    contractInfo?: EquityContractType
    /** 扩展信息 */
    extraInfo?: {
        style: string;
    };
    title?: string;
};

/** 超级会员不同入口场景枚举 */
export enum SuperMemberSceneEnum {
    /** 我的页面 */
    MY_PAGE = 10,
    /** 优惠卷列表页面 */
    COUPON_LIST = 11,
    /** 提现单列表页面 */
    LOAN_ORDER_LIST = 12,
    /** 贷超协议页 */
    LOAN_SUPERMARKET_AGREEMENT_SCENE = 28,
    /** 分期商城授信协议页 */
    FQ_MALL_AGREEMENT_SCENE = 31,
}

export type CheckSuperCardMyPageShow = {
    /** 购买状态 */
    packageBuyStatus: number;
    /** 订单ID */
    orderId?: string;
    /** 权益包ID */
    packageId: string;
    /** 权益包名称 */
    packageName: string;
    /** 权益包类型 */
    packageType: RightPackageTypeEnum;
    /** 供应商code */
    supplierCode: string;
    /** 权益包售价 */
    sellPrice: string;
    /** 扩展信息 */
    extraInfo?: {
        /** 样式枚举 */
        style?: string;
        /** 模式枚举，patternA：线上带金融权益的样式， patternB：合规样式*/
        pattern?: string;
    };
}

/** 当前权益版式测试枚举 我的页面使用 废弃版本 之后下线 */
export enum SuperCardStyleTypeEnum {
    /** 样式A */
    STYLE_A = 'A',
    /** 样式B */
    STYLE_B = 'B',
}

/** 当前权益版式测试枚举 */
export enum NewSuperCardStyleTypeEnum {
    /** 样式A */
    STYLE_A = 'styleA',
    /** 样式B */
    STYLE_B = 'styleB',
    /** 默认样式 */
    DEFAULT = 'default',
}


/** 支付方式 */
export enum PayWayEnum {
    /** 银行卡 */
    Card = 2,
    /** 支付宝 */
    ALI_PAY = 1,
}


/** 根据场景查询合同协议列表 */
export interface GetContrackListParamType {
    /** 合同场景 */
    scene: string;
    /** 权益模型标识 为了区分24+权益使用新的库表给后端透传的字段  */
    rightsModelType?: number,
}

export interface GetContractNameParamType {
    packageId: string;
    payWay: PayWayEnum;
}

/** 根据场景查询合同协议列表 */
export interface GetContrackDetailParamType {
    /** 合同模版id */
    templateId: string;
    /** 额外参数 */
    extraParams?: Record<string, string>;
}

/** 合同协议列表类型 */
export interface ContractListType {
    /** 合同模版id */
    templateId: string;
    /** 合同名称 */
    contractName: string;
    /** 合同类型 */
    contractType: string;
    contractUrl: string;
}

/** 根据卡种查询合同阅读状态 */
export interface GetContractReadParamType {
    /** 卡种 */
    packageType: RightPackageTypeEnum;
    sceneCode: string;
}

/** 根据卡种查询合同阅读状态 */
export interface ContractReadParamType {
    /** 卡种 */
    packageType: RightPackageTypeEnum;
}

/** 合同详情类型 */
export interface ContractDetailType {
    /** 合同详情链接 */
    contractUrl: string;
}

export interface getCreditBuyEquityParamType {
    productIds: number[];
    productList: {
        productId: number;
        followLoan: boolean;
    }[]
}


export interface GetSuperMemberReqType {
    sceneType?: SuperMemberSceneEnum;
    productId?: string;
    rateValue?: number;
    pricingType?: PricingTypeEnum;
    packageType?: RightPackageTypeEnum;
    /** 业务版本号 */
    bizVersion?: string;
}

export enum GalileoExpSceneEnum {
  /** 臻享卡交互调整(上下选择)测试: https://ab.hellobike.cn/experiment/detail/202507171616320724?isDetail=true */
  ZXK_LOAN_RIGHTS_MODEL_INTERACTION_AB = 'zxk_loan_rights_model_interaction_ab',
  /** 提现页，权益交互流程实验测试 https://ab.hellobike.cn/experiment/detail/202507261355451606?isDetail=true */
  CHANNEL_B_DOUBLE_CAPITAL_MODEL_AMOUNT_LIMIT_AB = 'channel_b_double_capital_model_amount_limit_ab',
  /** 提现页，自营仅24+权益模式增加挽留弹窗 https://ab.hellobike.cn/experiment/detail/202508201728291252?labGuid=202211211841286660&isDetail=true */
  CHANNEL_B_KEEP_POPS_UP_EXP_AB = 'channel_b_keep_pops_up_exp_ab',
  // 36双承接上下交互流程实验 https://ab.hellobike.cn/experiment/detail/202508181104396322?labGuid=202211211841286660&isDetail=true
  CHANNEL_B_DOUBLE_CAPITAL_MODEL_UP_DOWN_AB = 'channel_b_double_capital_model_up_down_ab',
  /** 提现页，超会增加挽权益留弹窗实验 */
  SUPER_CARD_SUBMIT_RETAIN_POP_AB = 'super_card_submit_retain_pop_1030_ab',
  /** 提现页，增加挽权益留弹窗实验 */
  RIGHT_CARD_CHANGE_RETAIN_POP_1030_AB = 'rights_card_change_retain_pop_1030_ab',
}

/** 自营流程实验结果 */
export enum AutrakyProcessExpEnum{
  /** 页面默认状态，表示需要请求接口 */
  DEFAULT = -1,
  /** 实验结果命中小时限额弹窗 */
  LIMIT_QUOTE = 2,
  /** 实验结果命中对照组 */
  CONTROL = 3,
   /** 走挽留弹窗流程 */
  RETAIN_POP = 4,
}

export interface GetGalileoExpResult {
  /** 实验场景 */
  expScene: GalileoExpSceneEnum;
  /** 产品id */
  productId?: string;
  /** 卡种 */
  loanCardType?: LoanCardTypeEnum;
  /** 定价类型 */
  packageType?: RightPackageTypeEnum;
}

export enum GalileoExpStyleEnum {
  /** 样式A */
  STYLE_A = 'styleA',
  /** 样式B */
  STYLE_B = 'styleB',
}

export interface GetGalileoExpResultResponseType {
  /** 是否命中实验 */
  isHitExp: boolean;
  /** 自营流程实验结果,目前只会在scene = 'channel_b_double_capital_model_amount_limit_ab'时返回 */
  expGroupType?: AutrakyProcessExpEnum;
  /** 实验样式 */
  style?: GalileoExpStyleEnum;
}

/** f.loan.check.rightLight 接口参数类型 */
export interface CheckDualChannelLightParamsType {
  productId?: string;
  uncreditedProductId?: string;
}

/** f.loan.check.rightLight 接口返回类型 */
export interface CheckDualChannelLightResponseType {
  /** 轻资产承接校验结果 */
  checkResult: string;
  /** 弹窗提示信息 */
  failReason: string;
}
